// Copyright (c) 2016 Deere & Company

import '../../../../shared/components/labeled-string/index.scss';
import React, {PropTypes} from 'react';
import Dropdown from './dropdown';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';

const getStatusText = newStatus => newStatus && newStatus.key ? newStatus.key : 'SELECT_STATUS';

const getStatusValue = newStatus => newStatus && newStatus.value ? newStatus.value : 'SELECT_STATUS';

const NewStatusDropdown = ({newStatus, disabled, onItemChange, statuses}) =>
    <div className='labeled-string'>
        <span className='data-label'>
            <sup>{'*'}</sup> <FormattedMessage id='NEW_STATUS'/>
        </span>
        <Dropdown
            data={statuses}
            disabled={disabled}
            name='newStatus'
            onItemChange={onItemChange}
            text={getStatusText(newStatus)}
            value={getStatusValue(newStatus)}
        />
    </div>;

NewStatusDropdown.displayName = 'NewStatusDropdown';
NewStatusDropdown.propTypes = {
    disabled: PropTypes.bool,
    newStatus: PropTypes.instanceOf(KeyValuePair),
    onItemChange: PropTypes.func.isRequired,
    statuses: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired
};
NewStatusDropdown.defaultProps = {
    disabled: false
};

export default NewStatusDropdown;



// WEBPACK FOOTER //
// ./src/product/status-change-request/components/dropdowns/new-status-dropdown.js